import { useState } from "react";
import { useTranslation } from "react-i18next";
import { DeleteIcon } from "@chakra-ui/icons";
import {
    Accordion,
    AccordionButton,
    AccordionIcon,
    AccordionItem,
    AccordionPanel,
    Box,
    Button,
    IconButton,
    Tooltip
} from "@chakra-ui/react";
import AddSubCategoryModal from "./AddSubCategoryModel";
import DeleteSubcategory from "./DeleteSubcategory";
import { Category } from "./SingleCategoryPage";

interface ICategoryRecursion {
    category: Category,
    catComponent: any | null,
    resetData: () => void
}

const CategoryRecursion = (props: ICategoryRecursion) => {
    const [addModal, setAddModal] = useState<boolean>(false);
    const [deleteModal, setDeleteModal] = useState<boolean>(false);
    const [showDelete, setShowDelete] = useState<boolean>(false);
    const { t } = useTranslation("translations");

    return (
        <div>
            <Accordion allowMultiple={true} bg={"gray.100"} className="p-2 rounded">
                <AccordionItem>
                    <h2>
                        <AccordionButton
                            onClick={() => setShowDelete(!showDelete)}
                            className="space-x-2 rounded"
                            _expanded={{ bg: 'gray', color: 'white' }}
                        >
                            {showDelete ?

                                <IconButton
                                    onClick={() => { setDeleteModal(true) }}
                                    colorScheme='red'
                                    aria-label='Delete Categorie'
                                    icon={<DeleteIcon />}
                                    size={"sm"}
                                /> : <> </>
                            }
                            <Box as="span" flex='1' textAlign='left'>
                                {props.category.name.toUpperCase()}
                            </Box>
                            <AccordionIcon />
                        </AccordionButton>
                    </h2>
                    <AccordionPanel pb={4} boxShadow={"inner"} bg={"white"}>
                        {
                            props.category.subCategories ?
                                props.category.subCategories.map((c: Category, index: number) => {
                                    return (
                                        <>
                                            <div key={index}>
                                                <CategoryRecursion category={c} catComponent={CategoryRecursion} resetData={() => { props.resetData() }} />
                                            </div>
                                        </>
                                    )
                                }
                                )
                                : <> </>
                        }
                        <div className="flex justify-end p-2 space-x-2">
                            <Tooltip label={t("Add Subcategory")}>
                                <Button onClick={() => { setAddModal(true) }} placeItems={"left"} colorScheme='teal' size='sm'>
                                    {t("ADD")}
                                </Button>
                            </Tooltip>
                        </div>
                    </AccordionPanel>
                </AccordionItem>
            </Accordion>

            <AddSubCategoryModal
                isOpen={addModal}
                onClose={() => {
                    setAddModal(false)
                }}
                id={props.category?.id ? props.category?.id : ""}
                resetData={() => { props.resetData() }}
            />

            <DeleteSubcategory
                isOpen={deleteModal}
                onClose={() => {
                    setDeleteModal(false)
                }}
                id={props.category?.id ? props.category?.id : ""}
                name={props.category.name ? props.category.name : ""}
                resetData={() => { props.resetData() }}
            />
        </div>
    )
}


export default CategoryRecursion;